import React from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

//style rules
import { Sizes } from "../../styles";

const Slide = ({ slide }) => {
	const renderButton = () => {
		if (!slide.buttonLink) return;

		return (
			<Button
				href={slide.buttonLink}
				target={slide.buttonTarget}
				className="button"
			>
				{slide.buttonText}
			</Button>
		);
	};

	const renderImage = () => {
		if (!slide.image) {
			return (
				<img
					loading="lazy"
					src={mainScript.assetPath + "images/png/graphics/tab-placeholder.png"}
					alt=""
				/>
			);
		}

		return (
			<>
				<img
					loading="lazy"
					src={slide.image}
					alt={
						slide.altText.length > 0
							? slide.altText
							: `Image for ${slide.title} slide`
					}
				/>
				{slide.captionLine1 && (
					<figcaption className="fly-out-caption__container">
						<p className="fly-out-caption__text">{slide.captionLine1}</p>
						<p className="fly-out-caption__text fly-out-caption__text--line2">
							{slide.captionLine2}
						</p>
					</figcaption>
				)}
			</>
		);
	};

	const handleCaptionTrigger = (event) => {
		event.currentTarget.classList.toggle("expanded");
	};

	return (
		<Wrapper>
			<ContentContainer>
				<Title>{slide.title}</Title>
				{slide.text && (
					<Text dangerouslySetInnerHTML={{ __html: slide.text }} />
				)}
				{renderButton()}
			</ContentContainer>
			<ImageContainer onClick={handleCaptionTrigger} tabIndex="0">
				<AspectRatioContainer>{renderImage()}</AspectRatioContainer>
			</ImageContainer>
		</Wrapper>
	);
};

Slide.propTypes = {
	slide: PropTypes.shape({
		title: PropTypes.string,
		text: PropTypes.string,
		image: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
		altText: PropTypes.string,
		captionLine1: PropTypes.string,
		captionLine2: PropTypes.string,
		buttonText: PropTypes.string,
		buttonLink: PropTypes.string,
		buttonTarget: PropTypes.string,
	}),
};

export default Slide;

const Wrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 3rem;
	margin-left: clamp(
		20px,
		calc((100vw - ${Sizes.grids.maxWidth}) / 2),
		calc((100vw - ${Sizes.grids.maxWidth}) / 2)
	);
	margin-right: clamp(
		20px,
		calc((100vw - ${Sizes.grids.maxWidth}) / 2),
		calc((100vw - ${Sizes.grids.maxWidth}) / 2)
	);
	padding: 5rem 0;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		flex-direction: row;
		gap: 9.24%;
		align-items: center;
		margin-left: 0;
		margin-right: 0;
		padding: 5rem 9.63%;
		
	}

	@media only screen and (min-width: calc(${Sizes.screens.xlarge} + 100px)) {
		&::after {
			content: "";
			position: absolute;
			top: 2rem;
			left: 9.63%;
			width: 4rem;
			height: 4rem;
			background-image: url(${mainScript.assetPath +
			"images/svg/graphics/star-white.svg"});
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center;
		}
	}

	@media only screen and (min-width: calc(${Sizes.screens.xlarge} + 250px)) {
		&::after {
			top: 5rem;
		}
	}
`;

const ContentContainer = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 2rem;
`;

const Title = styled.h4`
	font-size: 2.6rem;
	line-height: 2.7rem;
	text-align: left;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		font-size: 3rem;
		line-height: 3.6rem;
	}
`;

const Text = styled.p`
	text-align: left;
`;

const Button = styled.a`
	height: 100%;
`;

const ImageContainer = styled.div`
	flex: 1.13;

	&:hover {
		@media only screen and (min-width: ${Sizes.screens.large}) {
			.fly-out-caption__container {
				width: 100%;
				padding: 0.6rem 0.6rem 0.6rem 5.7rem;
				transition:
					padding 0.5s ease-in-out,
					width 0.5s ease-in-out;

				.fly-out-caption__text {
					opacity: 1;
					transition: opacity 0.5s ease-in-out;
				}
			}
		}
	}

	&.expanded {
		.fly-out-caption__container {
			padding: 0.6rem 0.6rem 0.6rem 3.8rem;
			width: 100%;

			@media only screen and (min-width: ${Sizes.screens.large}) {
				padding: 0.6rem 0.6rem 0.6rem 5.7rem;
			}

			.fly-out-caption__text {
				opacity: 1;
				transition: opacity 0.5s ease-in-out;
			}
		}
	}
`;

const AspectRatioContainer = styled.div`
	position: relative;
	width: 100%;
	display: block;
	padding-top: calc(32.3 / 36.2 * 100%);
	overflow: hidden;
	border-radius: 60px;

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		padding-top: calc(41.2 / 46.2 * 100%);
	}

	img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center center;
	}

	.fly-out-caption__text {
		text-align: left;
	}
`;
